import { useMemo } from "react";
import { applyEditsToConsolidatedData } from "../business_rules/applyEditsToConsolidatedData";

export function useOtbConsolidatedEdits(geralData, editedByCategory) {
  const effectiveData = useMemo(
    () => applyEditsToConsolidatedData(geralData, editedByCategory),
    [geralData, editedByCategory]
  );

  return { effectiveData };
}